import { withI18n } from '@lingui/react'
import classNames from 'clsx'
import { bool, func, shape } from 'prop-types'
import { compose } from 'redux'

import { TENANT_COM } from 'shared/consts'
import { PAGE_TYPE_HOMEPAGE } from 'shared/consts/page'
import noop from 'shared/utils/noop'
import IconNew from 'views/components/atoms/Icon/IconNew'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import { shouldRenderErxAnnouncement } from 'views/components/organisms/Menubar/ErxTooltip/helpers'
import OffCanvasItem from 'views/components/organisms/OffCanvas/OffCanvasItem'
import Device from 'views/components/utils/Device'
import Tenant from 'views/components/utils/Tenant'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isRedPointsActive } from 'views/utils/featureToggleUtils'
import {
  i18nType,
  mountPointsType,
  offCanvasCategory,
} from 'views/utils/propTypes'

const OffCanvasItemList = ({
  data,
  i18n,
  goNextHandler,
  mountPoints,
  showCategoryTitle,
  ghosts,
  publicRuntimeConfig: {
    pageProperties: { featureToggles, path, pageType, upNavTree },
  },
}) => {
  const liClassName = classNames({
    'o-Offcanvas__Item--indented': showCategoryTitle,
  })

  const isHomePage = pageType === PAGE_TYPE_HOMEPAGE

  const redPointsToggleIsActive = isRedPointsActive(featureToggles)

  // this is needed since bully has different names for 'subcategories',
  // depending on the level of category you are querying :(
  const categories = data.subCategories || data.subcategories

  // Don't allow multiple announcements be rendered
  let isAnnouncementFound
  const subCats = categories.filter(category => category.hasSubcategories)

  return (
    <ul className="a-list-reset">
      {showCategoryTitle && (
        <li>
          <OffCanvasItem href={data.canonicalUrl}>{data.name}</OffCanvasItem>
        </li>
      )}

      {categories.map(({ id, canonicalUrl, hasSubcategories, name }, index) => {
        if (!redPointsToggleIsActive && name === 'RedPoints') {
          return null
        }
        const isLast = index + 1 === categories.length

        const hasErxAnnouncement =
          !isAnnouncementFound && shouldRenderErxAnnouncement(canonicalUrl)
        if (hasErxAnnouncement) {
          isAnnouncementFound = true
        }

        const OwnProductsLink =
          !upNavTree.length &&
          !isLast &&
          !isHomePage &&
          path &&
          subCats[0]?.id === categories[index + 1].id ? (
            <li className="o-Offcanvas__Item--indented">
              <OffCanvasItem
                href={`${mountPoints.getCmsAllProductsFromCategory(
                  path
                )}?ownBrands=true`}
              >
                {i18n._('category.label.ownBrands')}
              </OffCanvasItem>
            </li>
          ) : null

        return (
          <>
            {OwnProductsLink}
            <li
              className={liClassName}
              key={id}
              data-clientside-hook={
                hasErxAnnouncement ? 'handle-erx-announcement' : null
              }
            >
              <OffCanvasItem
                id={id}
                href={canonicalUrl}
                hasSubcategories={hasSubcategories}
                goNextHandler={goNextHandler}
                ghost={ghosts}
              >
                {name}
                {hasErxAnnouncement && (
                  <Device mobile tablet>
                    <Tenant tenant={TENANT_COM}>
                      {() => (
                        <div
                          className="u-color--blue"
                          data-clientside-hook="wrap-erx-announcement"
                        >
                          <TextWithIcon icon={<IconNew />}>
                            <div className="a-h4 u-font-weight--bold u-no-margin">
                              E-Rezept einlösen
                            </div>
                          </TextWithIcon>
                        </div>
                      )}
                    </Tenant>
                  </Device>
                )}
              </OffCanvasItem>
            </li>
          </>
        )
      })}
    </ul>
  )
}

OffCanvasItemList.propTypes = {
  data: offCanvasCategory.isRequired,
  goNextHandler: func,
  showCategoryTitle: bool,
  ghosts: bool,
  publicRuntimeConfig: shape({}),
  mountPoints: mountPointsType.isRequired,
  i18n: i18nType.isRequired,
}

OffCanvasItemList.defaultProps = {
  goNextHandler: () => noop,
  showCategoryTitle: false,
  ghosts: false,
  publicRuntimeConfig: {},
}

export default compose(
  withShopAndRuntimeConfig,
  withI18n(),
  withMountPoints
)(OffCanvasItemList)
